import { createProgramacaoColetaApi } from "@/contexts/laboratorio/programacaoColeta/api/programacaoColetaApi";
import { ProgramacaoColetaAnalise } from "@/contexts/laboratorio/programacaoColeta/model/ProgramacaoColetaAnalise";
import {
  getProgramacaoSynced,
  programacaoAction,
} from "@/contexts/laboratorio/programacaoColeta/store/programacaoColetaAnaliseSlice";
import { SelectOption } from "@/shared/types/SelectOption";
import dayjs from "dayjs";
import { useState } from "react";
import { useAuth } from "react-oidc-context";
import { useDispatch, useSelector } from "react-redux";

export const useProgramacaoColetaAnalise = () => {
  const { user } = useAuth();
  const programacaoColetaApi = createProgramacaoColetaApi(user?.access_token);
  const appDispatch = useDispatch();
  const { sync } = programacaoAction;
  const listaProgramacoes = useSelector(getProgramacaoSynced);
  const [programacoesOptions, setProgramacoesOptions] = useState<
    SelectOption[]
  >([]);

  const sincronizarProgramacoes = (items: ProgramacaoColetaAnalise[]) => {
    appDispatch(sync(items));
  };

  const getProgramacoesApi = programacaoColetaApi.listAll;

  const getProgramacoesByEstabelecimento = (estabelecimentoId: number) => {
    const programacoes = listaProgramacoes.filter(
      (programacao) =>
        programacao.estabelecimento?.id === estabelecimentoId &&
        programacao.ativo
    );

    const options = programacoes.map((programacao) => {
      const itemLabel = programacao.agua
        ? "Água"
        : `${programacao?.produto?.produto?.nome} - ${programacao?.produto?.numeroRotulo}`;

      return {
        label: `${dayjs(programacao.dataProgramada).format("DD/MM/YYYY")} - ${itemLabel}`,
        value: programacao.id,
      };
    });

    setProgramacoesOptions(options);
  };

  const getProgramacaoById = (id: number) => {
    return listaProgramacoes.find((programacao) => programacao.id === id);
  };

  return {
    listaProgramacoes,
    sincronizarProgramacoes,
    getProgramacoesApi,
    programacoesOptions,
    getProgramacoesByEstabelecimento,
    getProgramacaoById,
  };
};
